<template>
    <div>
      <buttons-group
          :items="items"
          :indexStep="index"
          :disabledAll="false"
          @click="getIndex"
      />
    </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      items: [ 'Dados Cadastrais', 'Classificação', 'Hierarquia', 'Endereço' ],
      disabled: true
    }
  },
  methods: {
    getIndex (index) {
      this.$emit('changeButton', index)
    }
  }

}
</script>
